<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-2">Gestión de Ordenes de Producción</h1>
            </v-flex>
        </v-layout>
        <v-progress-linear :indeterminate="indeterminado" :active="loading" height="5"></v-progress-linear>
        <v-layout row wrap>
            <v-flex xs12 sm4>
                <v-flex v-if="mostrarEmpresa">
                    <empresa-select v-model="empresa_id" :filtro="emp"></empresa-select>
                </v-flex>
                <v-date-picker locale="es-sp" v-model="fecha"></v-date-picker>
                <v-btn color="primary" @click.native="mostrar()" :loading="loading">Mostrar</v-btn>
                <v-switch label="Mostrar solo faltantes" v-model="faltantes"></v-switch>
            </v-flex>
            <v-flex xs12 sm8>
                <v-tabs v-model="tabActiva" color="primary" dark centered grow>
                    <v-tab :key="1" ripple>Faltante por orden de prod</v-tab>
                    <v-tab :key="2" ripple>Faltante por componente</v-tab>
                    <v-tab-item :key="1">
                        <div class="display-1">Faltante por Orden de Producción</div>
                        <v-data-table :headers="headers" :items="ops" item-key="C2_OP" dense class="tabla-compacta-col">
                            <template slot="items" slot-scope="props">
                                <tr @click="props.expanded = !props.expanded">
                                    <td class="text-xs-center">
                                        <v-icon
                                                :color="(props.item.falta === true)? 'red' : 'green' "
                                                v-text="(props.item.falta === true)? 'clear' : 'done' "
                                        ></v-icon>
                                    </td>
                                    <td class="text-xs-center">{{ props.item.C2_OP }}</td>
                                    <td class="text-xs-center">{{ props.item.C2_PRODUTO }} | {{ props.item.B1_DESC }}</td>
                                    <td class="text-xs-right">{{ props.item.C2_QUANT | decimales }}</td>
                                    <td class="text-xs-right">{{ props.item.C2_QUJE | decimales }}</td>
                                </tr>
                            </template>
                            <template slot="expand" slot-scope="props">
                                <v-card color="primary">
                                    <v-card-text>
                                        <v-data-table color="blue" :headers="headers2" :items="props.item.stock" :rows-per-page-items="rowsPerPage">
                                            <template slot="items" slot-scope="props">
                                                <tr @click="saldosGet($event,props.item.D4_COD,props.index)">
                                                    <td class="text-xs-center">
                                                        <v-progress-circular width="2" size="17" indeterminate color="primary" v-if="props.index === saldoLoading"></v-progress-circular>
                                                        <v-icon v-if="props.index !== saldoLoading"
                                                                :color="(parseFloat(props.item.FALTA) <= 0)? 'green' : 'red'"
                                                                v-text="(parseFloat(props.item.FALTA) <= 0)? 'done' : 'clear'"
                                                        ></v-icon>
                                                    </td>
                                                    <td>{{ props.item.D4_COD }} | {{ props.item.B1_DESC }}</td>
                                                    <td class="text-xs-center">{{ props.item.D4_LOCAL }}</td>
                                                    <td class="text-xs-right " :class="{'red--text': parseFloat(props.item.FALTA) > 0}">
                                                        {{ props.item.FALTA | decimales }} {{ props.item.B1_UM}}

                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item :key="2">
                        <div class="display-1">Faltante total por componente</div>
                        <v-data-table :headers="headers3" :items="ar" :rows-per-page-items="rowsPerPage" dense class="tabla-compacta-col">
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td>
                                        <v-icon
                                                :color="(props.item.FALTA <= 0)? 'green' : 'red' "
                                                v-text="(props.item.FALTA <= 0)? 'done' : 'clear' "
                                        ></v-icon>
                                    </td>
                                    <td>{{ props.item.B1_COD }}</td>
                                    <td>{{ props.item.B1_DESC }}</td>
                                    <td>{{ props.item.D4_LOCAL }}</td>
                                    <td class="text-xs-right">{{ props.item.FALTA | decimales }} {{ props.item.B1_UM}}</td>
                                    <td class="text-xs-right">{{ props.item.TOTAL | decimales }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs>
            </v-flex>
        </v-layout>
        <v-menu v-model="saldoShow"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
                max-width="500"
        >
            <v-card max-width="500">
                <v-card-text>
                    <template v-for="item in saldos">
                        <span><b>{{ item.B2_LOCAL }}:</b> {{ item.B2_QATU | decimales }}</span>
                        <br>
                    </template>
                </v-card-text>
            </v-card>
        </v-menu>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue';
    import userMixin from '../../mixins/auth/users';
    import pcpMixin from '../../mixins/pcp';
    import mixinSaldos from '../../mixins/stock/saldos'
    import decimales from '../../filters/decimales';


    export default {
        components: {empresaSelect},
        mixins: [userMixin, pcpMixin, mixinSaldos],
        filters: {decimales},
        data() {
            return {
                x: 0,
                y: 0,
                saldoShow: false,
                saldoLoading: -1,
                saldos: [],
                ordenSel: [],
                ordenSelTodo: false,
                tabActiva: 0,
                fecha: new Date().toISOString().substr(0, 10),
                loading: false,
                empresa_id: '',
                mostrarEmpresa: false,
                indeterminado: true,
                headers: [
                    {text: 'Estado', value: 'falta', align: 'center'},
                    {text: 'OP', value: 'C2_PRODUTO', align: 'center'},
                    {text: 'Prod', value: 'C2_PRODUTO', align: 'center'},
                    {text: 'Cant', value: 'C2_QUANT', align: 'center'},
                    {text: 'Producido', value: 'C2_QUJE', align: 'center'}
                ],
                headers2: [
                    {text: 'Estado', value: 'FALTA', align: 'center'},
                    {text: 'Comp', value: 'D4_COD', align: 'center'},
                    {text: 'Dep', value: 'D4_LOCAL', align: 'center'},
                    {text: 'Falta', value: 'FALTA', align: 'center'}
                ],
                headers3: [
                    {text: 'Estado', value: 'FALTA', align: 'center'},
                    {text: 'Cód', value: 'B1_COD', align: 'center'},
                    {text: 'Desc', value: 'B1_DESC', align: 'center'},
                    {text: 'Dep', value: 'D4_LOCAL', align: 'center'},
                    {text: 'Falta', value: 'FALTA', align: 'center'},
                    {text: 'Total', value: 'TOTAL', align: 'center'}
                ],
                rowsPerPage: [{text: 'Todos', value: -1}, 5, 15, 25],
                emp: [],
                ops: [],
                ar: [],
                faltantes: false
            };
        },
        mounted() {
            this.getUserEmpresas(r => {
                if (r.length > 1) {
                    this.mostrarEmpresa = true;
                    this.emp = r;
                } else {
                    this.empresa_id = r[0];
                    this.mostrarEmpresa = false;
                }
            });
        },
        methods: {
            saldosGet(e, cod, index) {
                e.preventDefault();
                this.saldoLoading = index;
                this.saldoShow = false;
                this.x = e.clientX;
                this.y = e.clientY;
                this.saldoSb2({
                    emp: this.empresa_id, cod: cod
                }, r => {
                    this.saldos = r;
                    this.$nextTick(() => {
                        this.saldoShow = true;
                        this.saldoLoading = false;
                    })
                }, err => console.log(err));
            },
            mostrar() {
                if (!this.empresa_id) {
                    return false;
                }
                this.loading = true;
                this.$http
                    .post('pcp/ord-prod/muestra-stock', {empresa_id: this.empresa_id, fecha: this.fecha, faltantes: this.faltantes})
                    .then(r => {
                        this.ops = r.data.ops;
                        this.ar = r.data.ar;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            },
        }
    };
</script>
<style>
    table.datatable thead th {
        text-align: center !important;
    }

    /*.v-tabs .v-window {*/
    /*max-height: 400px !important;*/
    /*overflow-y: auto !important;*/
    /*}*/
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/pcp/op-gestion.vue